import { all } from "redux-saga/effects"
import authSagaWatcher from "./components/auth/auth-saga"
import countriesSagaWatcher from "./components/countries/countries-saga"
import usersSagaWatcher from "./components/users/users-saga"
import installersSagaWatcher from "./components/installers/installers-saga"
import floorsSagaWatcher from "./components/floors/floors-saga"
import floorCategoriesSagaWatcher from "./components/floor-categories/floor-categories-saga"
import floorTypesSagaWatcher from "./components/floor-types/floor-types-saga"
import contactsSagaWatcher from "./components/contacts/contacts-saga"
import teamMembersSagaWatcher from "./components/team-members/team-members-saga"
import videosSagaWatcher from "./components/videos/videos-saga"
import colorsSagaWatcher from "./components/colors/colors-saga"
import reviewsSagaWatcher from "./components/reviews/reviews-saga"
import meSagaWatcher from "./components/me/me-saga"

export default function* rootSaga() {
    yield all([
        authSagaWatcher(),
        meSagaWatcher(),
        countriesSagaWatcher(),
        usersSagaWatcher(),
        installersSagaWatcher(),
        floorsSagaWatcher(),
        floorCategoriesSagaWatcher(),
        floorTypesSagaWatcher(),
        contactsSagaWatcher(),
        teamMembersSagaWatcher(),
        videosSagaWatcher(),
        colorsSagaWatcher(),
        reviewsSagaWatcher()
    ])
}